import Vue from 'vue';
import Vuex from 'vuex';
import publicPlatform from './public-platform';
import { getCookie, setCookie } from '@/utils/cookie';
import { ApiGetUserInfo } from '@/api/user';
Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        loginStatus: 'on',
        publicPlatform,
        token: getCookie('token'),
        userInfo: {},
        isBeginLoadChildApp: false, // 是否开始加载子应用
        permissionRouters: [], // 权限路由
        isCollapse: window.localStorage.getItem('isCollapse') === 'true', // 侧边栏是否收起
        // 允许当前路由跳转
        allowRouterJump: {
            promise: Promise.resolve(),
            resolve: null,
            reject: null,
            callback: null
        }
    },
    getters: {
        permissionRouters: state => state.permissionRouters,
        isBeginLoadChildApp: state => state.isBeginLoadChildApp,
        isCollapse: state => state.isCollapse,
        userInfo: state => state.userInfo,
        // 需要初始化给子应用的数据
        initChildAppState: state => ({
            token: state.token,
            permissionRouters: state.permissionRouters,
            userInfo: state.userInfo,
            loginStatus: state.loginStatus,
            channel: 'xdSaaSbd'
        }),
        allowRouterJump: state => state.allowRouterJump
    },
    mutations: {
        SET_TOKEN(state, payload) {
            state.token = payload;
            setCookie('X-SourceCode', 'SAAS', {
                domain: location.hostname.replace(/.*?\./, '')
            });
            setCookie('token', payload, {
                domain: location.hostname.replace(/.*?\./, '')
            });
        },
        SET_USERINFO(state, payload) {
            state.userInfo = payload;
            setCookie('tenantId', payload.tenantId, {
                domain: location.hostname.replace(/.*?\./, '')
            });
        },
        SET_PERMISSIONROUTERS(state, payload) {
            state.permissionRouters = payload;
        },
        SET_ISBEGINCHILDAPP(state, payload) {
            state.isBeginLoadChildApp = payload;
        },
        SET_ISCOLLAPSE(state, payload) {
            state.isCollapse = payload;
        },
        SET_ALLOWROUTERJUMP(state, payload) {
            state.allowRouterJump = payload;
        }
    },
    actions: {
        // 设置token
        set_token({ commit }, payload) {
            commit('SET_TOKEN', payload);
        },
        // 获取用户信息
        set_userInfo({ commit }) {
            return new Promise((resolve, reject) => {
                ApiGetUserInfo()
                    .then(res => {
                        const { data = {} } = res;
                        commit('SET_USERINFO', data);
                        resolve(data);
                    })
                    .catch(err => {
                        reject(err);
                    });
            });
        },
        set_permissionRouters({ commit }, payload) {
            commit('SET_PERMISSIONROUTERS', payload);
        },
        set_IsBeginLoadChildApp({ commit }, payload) {
            commit('SET_ISBEGINCHILDAPP', payload);
        },
        // 侧边栏是否收起
        set_IsCollapse({ commit }, payload) {
            commit('SET_ISCOLLAPSE', payload);
        },
        set_AllowRouterJump({ commit }, payload) {
            commit('SET_ALLOWROUTERJUMP', payload);
        }
    },
    modules: {}
});
